import React, {useState} from "react";
import './Contact.scss'
import {Link} from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import {useForm} from "react-hook-form";
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
const Contact = () => {
    const {register, handleSubmit, watch, formState: {errors}} = useForm();
    const [firstName, setFirstName] = useState()
    const onSubmit = (e) => {
        e.preventDefault()
        e.target.reset()
    }
    return (
        <>
            <div className={'goBack'}><Link to={'/'}><HomeIcon className={'back'}/></Link></div>
            <div className={'contactContainer'}>
                <div className={'rightContainer'}>

                    <div className={'phoneNumber'}>
                        <LocalPhoneIcon/>
                        <div>6138162140</div>
                    </div>
                    <div className={'email'}>
                        <EmailIcon/>
                        <a href="mailto:wang19971125@gmail.com">wang19971126@gmail.com</a>
                    </div>
                    <div className={'address'}>
                        <HomeIcon/>
                        <div>Ottawa, ON, Canada</div>
                    </div>

                </div>


                {/*<form onSubmit={handleSubmit(onSubmit)}>*/}
                {/*    <input placeholder={'First Name'}  {...register("firstName", {required: true, minLength: 1, maxLength: 100})}*/}
                {/*           style={errors.firstName && {border: "0px solid red"}}*/}
                {/*           onChange={(e)=>{*/}
                {/*               setFirstName(e.target.value)*/}
                {/*           }}*/}
                {/*    />*/}
                {/*    {errors.firstName && errors.firstName.type === "required" &&*/}
                {/*    <span className={'errorText'}>First name is required</span>}*/}
                {/*    {errors.firstName && errors.firstName.type === "minLength" &&*/}
                {/*    <span className={'errorText'}>This field is required min length of 1</span>}*/}
                {/*    {errors.firstName && errors.firstName.type === "maxLength" &&*/}
                {/*    <span className={'errorText'}>This field is required max length of 99</span>}*/}

                {/*    <input {...register("lastName", {required: true, pattern: /^[A-Za-z]+$/i})}*/}
                {/*    placeholder={'Last Name'}*/}
                {/*           style={errors.firstName && {border: "0px solid red"}}*/}
                {/*    />*/}
                {/*    {errors.lastName && <span className={'errorText'}>Last name is required</span>}*/}
                {/*    <input className={'.submitButton'} type="submit" />*/}
                {/*</form>*/}


            </div>
        </>

    )

}


export default Contact
